import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddZileLiberePayload, IEditZileLiberePayload } from './zile-libere.interface';

@Injectable({
    providedIn: 'root',
})
export class ZileLibereService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    //Getters
    private getZileList =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.zileLibere.list;
    private getZileListDT =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.zileLibere.listDT;

    //Update
    private storeZileURL =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.zileLibere.store;
    private putZileURL =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.zileLibere.update;

    //Delete
    private deleteZileURL =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.zileLibere.delete;

    constructor(private http: HttpClient) { }

    getZileLibereDT() {
        return this.http.post(this.getZileListDT, this.httpOptions);
    }

    addZileLibere(zileLibere: IAddZileLiberePayload) {
        return this.http.post(this.storeZileURL, zileLibere, this.httpOptions);
    }

    updateZileLibere(zileLibere: IEditZileLiberePayload) {
        return this.http.put(this.putZileURL, zileLibere, this.httpOptions);
    }

    deleteZileLibere(zileLibereId: number) {
        return this.http.delete(this.deleteZileURL + zileLibereId);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
